// Shared by the seller editor, checkout themes and embed app.
// This validates URL syntax only; YouTube controls availability and embedding.
export function getYoutubeVideoId (value) {
  if (typeof value !== 'string') return ''

  const input = value.trim()
  if (!/^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//i.test(input) ||
    /[\s<>"'`\\]/.test(input)) return ''

  try {
    const url = new URL(/^https?:\/\//i.test(input) ? input : 'https://' + input)
    let id = ''

    if (url.hostname === 'youtu.be' || url.hostname === 'www.youtu.be') {
      const match = url.pathname.match(/^\/([A-Za-z0-9_-]{11})\/?$/)
      id = match ? match[1] : ''
    } else if (url.hostname === 'youtube.com' || url.hostname === 'www.youtube.com') {
      if (url.pathname === '/watch') {
        const ids = url.searchParams.getAll('v')
        id = ids.length === 1 ? ids[0] : ''
      } else {
        const match = url.pathname.match(/^\/(shorts|embed|v)\/([A-Za-z0-9_-]{11})\/?$/)
        id = match ? match[2] : ''
      }
    }

    return /^[A-Za-z0-9_-]{11}$/.test(id) ? id : ''
  } catch (error) {
    return ''
  }
}

export function youtubeUrlValidator (value) {
  return Boolean(getYoutubeVideoId(value))
}
